














import { Component, namespace, mixins } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import { STORES_API } from '~/assets/config/api-path'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'
import { IImageVariants } from '~/assets/interfaces/images'
import ComponentStoresItem from '~/components/stores/stores-item.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'

const pageStore = namespace('page')

interface IStoreItem {
  id: number
  address: string
  title: string
  phone: string
  time: string
  url: string
  email: string
  image?: IImageVariants
}

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentStoresItem,
  },
})
export default class pageNews extends mixins(MixinGeneral) {
  private async asyncData({ $axios }: Context) {
    const response = await $axios.$get(filterUrl(STORES_API))

    return response
  }

  private items: IStoreItem[] = []

  private get hideImageColumn() {
    return !this.items.some((e: IStoreItem) => !!e.image)
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private created(): void {
    this.setMeta({
      title: 'Наши магазины',
      h1: 'Наши магазины',
    })
  }
}
